// import '@siemens/ix/dist/siemens-ix/siemens-ix.css';
// import '@siemens/ix/dist/siemens-ix/theme/classic-light.css';
import { defineCustomElements } from '@siemens/ix/loader';
import { defineCustomElements as defineIxIconCustomElement } from '@siemens/ix-icons/loader';
// import { ModuleRegistry } from 'ag-grid-community';
// import { AllCommunityModule } from 'ag-grid-community';

// ModuleRegistry.registerModules([AllCommunityModule]);

(async () => {
  defineIxIconCustomElement();
  defineCustomElements();
})();

// import { themeSwitcher } from '@siemens/ix';
// themeSwitcher.setTheme('dark');